"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptRecoveredEventData = void 0;
class MessageAttemptRecoveredEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptRecoveredEventData.attributeTypeMap;
    }
}
exports.MessageAttemptRecoveredEventData = MessageAttemptRecoveredEventData;
MessageAttemptRecoveredEventData.discriminator = undefined;
MessageAttemptRecoveredEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "lastAttempt",
        "baseName": "lastAttempt",
        "type": "MessageAttemptFailedData",
        "format": ""
    },
    {
        "name": "msgEventId",
        "baseName": "msgEventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "msgId",
        "baseName": "msgId",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptRecoveredEventData.js.map